import React, { useEffect, useMemo } from "react";
import { Fragment } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { useState } from "react";
import LoadingPage from "../../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import { CheckPosition } from "../../Function/CheckPosition";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_CORS;

function UserDeduct(props) {
  const {userInfo, windowSize} = props
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const navigate = useNavigate();

  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataInfo, setDataInfo] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [year, setYaer] = useState(null);
  const [allYearUser, setAllYearUser] = useState(null)
  // const [role, setRole] = useState(null);

  const fetchFileData = () => {
    const url = `${API_URL}/api/reduceTaxSlip/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "year",
      "order[1]": "DESC",
      // search: pushkeyword,
      // "filter[user_id][0]": 1205,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then((response) => {
        setFileData(response.data.result);
        const arr = []
        response.data?.result?.map(i => arr.push(i.year))
        const uniqueDataSet = [...new Set(arr)];
        setAllYearUser(uniqueDataSet);
        setDataInfo(() => response.data.info);
        setTotalPages(Math.ceil(response.data.info.totalRows / 10));
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      fetchFileData();
      setLoading(false);
    }, 1500);
  }, [currentPage]);

  const handleFetchYearDeduct = (id, year) => {
    const url_api = `${API_URL}/api/reduceTaxSlip/user/${id}/${year}`;
    // const axios = require("axios");

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: url_api,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        // console.log(response.data)
        window.open(API_URL + response.data.publicPath, "_blank");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (userInfo) {
      if (CheckPosition(userInfo?.position) && CheckPosition(userInfo?.position).includes(1)){
        navigate("/assessment");
      }
    }
  }, [userInfo]);

  return (
    <Row>
      <Col lg={1} className="me-2">
        <Label className="text-nowrap pe-2 mt-2 text-end" style={{fontSize: "16px"}}>ปี :</Label>
      </Col>
      <Col lg={4}>
        <Input
          id="date-end"
          type="select"
          onChange={e => setYaer(e.target.value)}
        >
          <option value={0}>กรุณาเลือก</option>
          {allYearUser?.map((year, index) =>
            {
              return(
                <option key={index} value={year}>
                    {year}
                  </option>
              )
            }
          )}
        </Input>
      </Col>
      
      { year && 
          fileData?.map((item, idx) => {
            if (item.year == year) {
              return (
                <Col lg={4} className={windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992 ) ? "mt-2" : ""}>
                  <Button
                    color="success"
                    onClick={() => {
                      handleFetchYearDeduct(
                        userData.user_id,
                        item.year
                      );
                    }}
                  >
                    <i className="fa-regular fa-print me-2"></i>
                    พิมพ์
                  </Button>
                </Col>
              ) 
            }
            
          })
      }
    </Row>
  );
}

export default UserDeduct;
